<template>
  <div>
    <b-card
      v-for="(entry, i) in answers"
      :key="i"
      bg-variant="light"
      class="mb-2"
      header-class="px-2"
      no-body
    >
      <template #header>
        <h4
          class="m-0"
          @click="isOpen[i].open = !isOpen[i].open"
          style="cursor: pointer"
        >
          {{ entry.form.name }}
        </h4>
        <div v-if="user.role === UserRoleEnum.ADMIN" class="small">
          {{ entry.form.id }}
        </div>
      </template>
      <b-collapse v-model="isOpen[i].open">
        <b-card-body class="p-2">
          <b-card
            v-for="flow in entry.flows"
            :key="flow.id"
            bg-variant="light"
            class="mb-2"
            body-class="p-2"
            header-class="px-2"
          >
            <template #header>
              <h5 class="m-0">
                {{ flow.headline[locale] || flow.headline.de }}
              </h5>
            </template>
            <div v-for="(question, j) in flow.questions" :key="j" class="mb-4">
              <h6 class="font-weight-normal">
                {{ (question.title[locale] || question.title.de) | stripTags }}
              </h6>
              <div v-if="question.type === OrderFormQuestionTypeEnum.FILE">
                <img
                  :src="`/api/media/file/${question.answer}` | jwtToken"
                  style="max-width: 10rem"
                  class="d-block"
                  loading="lazy"
                  :alt="question.name"
                />

                <b-button
                  variant="outline-primary"
                  class="mt-1 mr-1"
                  @click="
                    viewImage(
                      question.title[locale] || question.title.de,
                      `/api/media/file/${question.answer}`,
                    )
                  "
                  target="_blank"
                >
                  View&nbsp;
                  <i class="material-icons align-middle">visibility</i>
                </b-button>

                <b-button
                  variant="outline-primary"
                  class="mt-1"
                  :href="`/api/media/file/${question.answer}` | jwtToken"
                  target="_blank"
                >
                  Download&nbsp;
                  <i class="material-icons align-middle">file_download</i>
                </b-button>
              </div>
              <p v-else class="font-weight-bold">
                {{ question.answer | stripTags }}
              </p>
            </div>
          </b-card>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import BaseInput from './mixins/BaseInput';
import { FORM_ANSWERS } from './_types';
import { OrderFormQuestionTypeEnum } from '@gid/models/dist/entities/order-form-questions/order-form-question-type';
import { UserRoleEnum } from '@gid/models';
import { mapGetters } from 'vuex';

export default {
  mixins: [BaseInput],
  props: {
    inputName: {
      type: String,
      default: FORM_ANSWERS,
    },
    answers: {
      type: Array,
    },
    open: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['user', 'locale']),
  },
  filters: {
    stripTags: function (string) {
      return string.replace(/<\/?[^>]+>/gi, ' ');
    },
  },
  data() {
    return {
      OrderFormQuestionTypeEnum,
      UserRoleEnum,
      isOpen: [],
    };
  },
  watch: {
    open() {
      this.initOpen();
    },
    answers() {
      this.initOpen();
    },
  },
  created() {
    this.initOpen();
  },
  methods: {
    initOpen() {
      this.isOpen = [...Array(this.answers.length)].map(() => ({
        open: this.open,
      }));
    },
    viewImage(title, url) {
      this.$bvModal.msgBoxOk(
        this.$createElement('img', {
          domProps: {
            src: this.$options.filters.jwtToken(url),
          },
          class: 'w-100',
        }),
        {
          title,
          size: 'xl',
          hideHeaderClose: false,
        },
      );
    },
  },
};
</script>
